import { Population, User } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { UserPopulationEntityConfig } from "./config";
import { UserPopulationFilters } from "./filters";
import { UserPopulationMethods } from "./methods";

@HyperEntity("user-population", UserPopulationEntityConfig)
export class UserPopulation extends extender(
  UserPopulationFilters,
  UserPopulationMethods,
) {
  @Fields.string({ dbName: "user_id" })
  userId = "";

  @Fields.string({ dbName: "population_id" })
  populationId = "";

  @Relations.toOne<UserPopulation, Population>(() => Population, "populationId")
  population?: Population;

  @Relations.toOne<UserPopulation, User>(() => User, "userId")
  user?: User;

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt? = new Date();

  @Fields.createdAt({ dbName: "created_at" })
  createdAt? = new Date();
}


